import React, { FunctionComponent } from "react"
import { iPackage } from "../../definitions/Package"

const PackageItem: FunctionComponent<iPackage> = ({ name }) => {
  console.log(name)

  return (
    <div className="content-item">
      <div className="content-block">
        <h3>{name}</h3>
      </div>
    </div>
  )
}

export default PackageItem
